import { List } from "@mui/material";
import { Add } from "@mui/icons-material";
import { ReactElement, useCallback, useState } from "react";
import { w2d2dApiClient } from "../../../w2d2d-api-client"
import ConnectionsPageEntry from "./ConnectionsPageEntry"
import { useLocation } from "react-router-dom";
import ShareDialog from "../../../../appfw/share/ShareDialog.tsx";
import Session from "../../../../appfw/authentication/Session.ts";
import { useSession } from "@toolpad/core";
import AppFwFab from "../../../../appfw/ui/buttons/AppFwFab.tsx";
import { useConnectionsControl } from "../../hooks/useConnectionsControl.tsx";

export default function ConnectionsPage() {

    const location = useLocation()

    const session = useSession<Session>()

    const { connections, removeConnection } = useConnectionsControl()
    const [inviteShareData, setInviteShareData] = useState<undefined | ShareData>()

    const handleClickInvite = useCallback(async () => {
        let invitation = await w2d2dApiClient.createInvitation()

        const inviter = session?.user.name ?? "Jemand"
        let inviteShareData = {
            title: "Einladung zu What-to-do-today",
            text: `${inviter} möchte mit Dir What-to-do-today nutzen`,
            url: w2d2dApiClient.appBaseUrl + `invitations/${invitation.id}`,
        }
        setInviteShareData(inviteShareData)

    }, [location, session, inviteShareData])

    let connectionsEl: ReactElement[] = []
    if (connections) {
        // TODO: use memo?
        connections.forEach((userId) => {
            connectionsEl.push(<ConnectionsPageEntry userId={userId} key={userId} onDelete={removeConnection} />)
        })
    }

    return (
        <>
            <List sx={{ width: '100%' }}>
                {connectionsEl}
            </List>

            <ShareDialog
                data={inviteShareData}
                text={"Benutze diesen Link, um jemanden zu What-to-do-today einzuladen"}
                onClose={() => setInviteShareData(undefined)}
            />
            <AppFwFab aria-label="Einladen" onClick={handleClickInvite}>
                <Add />
            </AppFwFab>
        </>
    )
}
